import { get } from 'svelte/store';
import { pop } from 'svelte-spa-router';

import { showNewsletterModal } from 'src/stores/ui/on-log-modals';
import { authLockedDeviceModal } from 'src/stores/device-runtime/firmware-ui';
import { includeDeviceModal } from 'src/stores/features/inclusion';
import { force_go_back } from 'src/services/native_container_requests_android';
import { app, os } from 'src/stores/session/native-bridge';
import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
import { stopBluetoothScanner } from 'src/helpers/inclusion_helpers';

export const on_back: () => void = () => {
	const isSidePanelOpen = get(sidePanelStateCombined).open;
	// close drawer if open
	if (isSidePanelOpen) {
		setSidePanelState({ open: false });
		return;
	}

	// Android - use normal 'back button' behavior if the drawer is closed
	if (!isSidePanelOpen && get(app) && get(os) !== 'IOS') force_go_back(false);

	if (get(showNewsletterModal)) {
		showNewsletterModal.set(false);
		return;
	}

	if (get(authLockedDeviceModal)) {
		// string/undefined
		authLockedDeviceModal.set(undefined);
		return;
	}

	if (get(includeDeviceModal).show) {
		if (get(app)) {
			stopBluetoothScanner();
		}
		includeDeviceModal.update((state) => {
			return (state = { ...state, show: false });
		});
		return;
	}

	pop();
};
